export enum TournamentStatusEnum {
  Pending = 'PENDING',
  Active = 'ACTIVE',
};

export enum AwardType {
  Credit = 'CREDIT'
};

export type TournamentCategory = string;

export type AdditionalAward = {
  awardId: Maybe<number>;
  awardSubType: unknown;
  awardType: AwardType;
  bonusPlanId: number;
  amountWithCurrency: string;
  id: number;
};

export type BonusPlan = {
  planId: Maybe<number>;
  planName: Maybe<string>;
  playable: boolean;
  bonusAmount: Maybe<number>;
  bonusAmounts: any;
  currency: string[];
  description: Maybe<string>;
  imageUrl: Maybe<string>;
  startDate: Maybe<string>;
  endDate: Maybe<string>;
  paymentSubmethod: any;
  additionalAward: Maybe<AdditionalAward>;
};

export type TournamentLeaderboardItem = {
  isCurrentPlace: boolean;
  rank: number;
  player: string;
  score: string;
  toWin: string;
};

export type TournamentLeaderboardListItemWithCategory = {
  category: Maybe<string>;
  leaderboardItems: Array<TournamentLeaderboardItem>;
  tournamentId: Maybe<number>;
};

export type TournamentLeaderboardListItem = {
  leaderboardItems: Array<TournamentLeaderboardItem>;
  tournamentId: Maybe<number>;
};

export type TournamentWithRanking = {
  tournament: Maybe<Tournament>;
  leaderboardItems: Array<TournamentLeaderboardItem>;
  userPositionWithNeighbors: Array<TournamentLeaderboardItem>;
};

export type TournamentsWithRanking = {
  activeTournaments: Array<Tournament>;
  pendingTournaments: Array<Tournament>;
  privateTournamentList: Array<Tournament>;
  tournamentsLeaderboardList: Array<TournamentLeaderboardListItem>;
};

export type TournamentWIthCategories = {
  categories: Array<TournamentCategory>;
  tournamentList: Array<Tournament>;
  tournamentLeaderboardList: Array<TournamentLeaderboardListItemWithCategory>;
};

export type TournamentAward = {
  id: number;
  type: Maybe<string>;
  noOfFreespin: Maybe<number>;
  loyaltyPoints: Maybe<number>;
  description: Maybe<string>;
  createdDate: Maybe<string>;
  lastModifiedDate: Maybe<string>;
  tournamentId: Maybe<number>;
  bonusPlanId: Maybe<number>;
  bonusPlan: BonusPlan;
  gameInfoId: any;
  awardRuleId: Maybe<number>;
  rankStart: Maybe<number>;
  rankEnd: Maybe<number>;
  rankType: Maybe<string>;
};

export type Tournament = {
  id: number;
  name: string;
  description: string;
  imageSrc: string;
  imageUrl?: string;
  prizeGC: number;
  prizeSC: number;
  startDate: string;
  endDate: string;
  includedTags: Maybe<Array<string>>;
  excludedTags: Maybe<Array<string>>;
  status: TournamentStatusEnum;
  buttonText: string;
  buttonUrl: string;
  awards: Maybe<Array<TournamentAward>>;
};

export type TournamentsWithLeaderboard = {
  tournament: Tournament;
  leaderboard: Array<TournamentLeaderboardItem>;
};

export type TournamentRanking = {
  id: number;
  tournamentId: number;
  partyId: number;
  points: number;
  ranking: number;
  rankingLast: number;
  rankingDate: string;
  awarded: null;
  awardedDate: null;
  amountBet: number;
  amountWin: number;
  betCount: number;
  winCount: number;
  userId: string;
  currency: string;
  nickname: string;
};

export type TournamentsState = {
  privateTournaments: Array<Tournament>;
  activeTournaments: Array<Tournament>;
  pendingTournaments: Array<Tournament>;
  categories: Array<TournamentCategory>;
  currentCategory: Maybe<TournamentCategory>;
  tournamentListByCategories: Array<Tournament>;
  tournamentLeaderboardListByCategories: Array<TournamentLeaderboardListItemWithCategory>;
  tournamentsLeaderboardList: Array<TournamentLeaderboardListItem>;
};

export type TournamentsPayload = {
  tournaments: Array<Tournament>;
  vipStatus?: string;
  isAuthenticated?: boolean;
};